import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const ProductCard = (props) => {
  const lang = useSelector((state) => state.lang);
  const currency = useSelector((state) => state.currency);
  const translations = useSelector((state) => state.translations);
  const getWord = (val) => {
    const value = val.trim().toLowerCase();
    const word = translations[lang][value] ? translations[lang][value] : val;
    return word;
  };
  const dispPrice = (val) => {
    val =
      currency.currency === "KWD" || currency.currency === "BHD"
        ? (currency.price * val).toFixed(3)
        : (currency.price * val).toFixed(2);
    return `${currency.currency} ${val}`;
  };
  const sizes = Object.values(props.sizes);
  return (
    <>
      <div className="card-product style-3">
        <div className="card-product-wrapper">
          <Link to={"/product/" + props.slug} className="product-img">
            <img
              className="lazyload img-product"
              data-src={props.image}
              src={props.image}
              alt="image-product"
            />
            <img
              className="lazyload img-hover"
              data-src={props.image}
              src={props.image}
              alt="image-product"
            />
          </Link>
          {sizes.length > 0 ? (
            <div className="size-list style-2">
              {sizes.map((size) => {
                return <span key={size}>{size}</span>;
              })}
            </div>
          ) : (
            ""
          )}
          {props.discount > 0 ? (
            <>
              <div className="on-sale-wrap text-end">
                <div className="on-sale-item">
                  -
                  {(
                    ((props.price - props.discount) / props.price) *
                    100
                  ).toFixed()}
                  %
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <div className="card-product-info">
          <Link to={"/product/" + props.slug} className="title link">
            {lang === "ar" ? props.title_ar : props.title}
          </Link>
          <div className="tf-product-info-price">
            {props.discount > 0 ? (
              <>
                <span className="price">{dispPrice(props.discount)}</span>
                <span className="compare-price">{dispPrice(props.price)}</span>
              </>
            ) : (
              <span className="price">{dispPrice(props.price)}</span>
            )}
          </div>
          <div className="avail-view-6">
            <Link
              to={"/product/" + props.slug}
              className="tf-btn btn-outline btn-5"
            >
              {getWord("SELECT OPTIONS")}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCard;
